module.exports = __webpack_public_path__ + "img/12.213af2d8.png";